module.exports = __webpack_public_path__ + "static/media/S1N7-5.8b07814d.svg";